import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetch } from "../../Util/axios_helper";

const initialState = {
  contractlistloaded: false,
  contractlist: [],
};
export const getContractList = createAsyncThunk("getContractList", async () => {
  return await fetch("Configuration/ContractList");
});

const contract_slice = createSlice({
  name: "contract",
  initialState: initialState,
  reducers: {
    showLoading: (state, data) => {
      state.contractlistloaded = data.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getContractList.pending, (state) => {
      state.contractlist = false;
    });

    builder.addCase(getContractList.fulfilled, (state, data) => {
      state.contractlist = data.payload;
      state.contractlistloaded = true;
    });

    builder.addCase(getContractList.rejected, (state) => {
      state.contractlist = [];
      state.contractlistloaded = true;
    });
  },
});

export const { showLoading } = contract_slice.actions;
export default contract_slice.reducer;
